"use strict";
import Handlebars from "handlebars/dist/handlebars.js";
import { displayGenericError, serviceNetworkError } from "../failhandler";

var ticketManagementForm = function (options) {

    var settings = $.extend({
        templateselector: '#ticket-management-template',
        statisticstemplateselector: '#statistics-template',
        formselector: '.ticket-management-form',
        servicemethod: null,
        statisticsservicemethod: null
    }, options);

    var form = $(settings.formselector),
        scanBtn = $('#scan-btn', form),
        responseWrap = $('.response-wrapper', form),
        invalidMessage = responseWrap.attr('data-invalid-message'),
        responseModal = $('.response-modal', form),
        scanSource = $(settings.templateselector, form).html(),
        scanTemplate = Handlebars.compile(scanSource),
        cl = new CanvasLoader('loader'),
        statisticsSource = $(settings.statisticstemplateselector, form).html(),
        statisticsTemplate = null,
        clStatistics = null,
        input = $('input:text', form),
        inputVal;

    cl.setDiameter(20);
    cl.setDensity(17);
    cl.setRange(1.1);
    cl.setSpeed(1);
    cl.setColor('#ffffff');
    cl.setFPS(24);

    if (statisticsSource !== undefined) {
        statisticsTemplate = Handlebars.compile(statisticsSource);
        clStatistics = new CanvasLoader('statistics');
        clStatistics.setDiameter(30);
        clStatistics.setDensity(17);
        clStatistics.setRange(1.1);
        clStatistics.setSpeed(1);
        clStatistics.setColor('#0094ce');
        clStatistics.setFPS(24);
    }

    scanBtn.removeAttr("type");

    form.on('click', '.close-modal', closeModal);
    form.on('click', '#scan-btn', scanTicket);
    form.on('click', '.statistics', showStatistics);
    form.on('click', '.olderstatistics', showOlderStatitics);

    input.focus();

    input.keydown(function (e) {
        if (e.which == 13) {
            if (e.preventDefault) {
                e.preventDefault();
            }
            else {
                e.returnValue = false;
            }

            scanBtn.click();

        }
        else if (responseModal.is(":visible") && $(".return-ticket").length > 0) {
            $(this).val("");
            closeModal();
        }

    });

    function scanTicket(e) {
        if (e.preventDefault) {
            e.preventDefault();
        }
        else {
            e.returnValue = false;
        }

        hideStatistics();

        inputVal = input.val();

        if (inputVal.length > 0) {

            var data = {
                "pageid": SETTINGS.pageid,
                "language": SETTINGS.language,
                "code": inputVal
            };

            scanBtn.addClass('loading');
            cl.show();
            responseWrap.hide();

            var ajaxRequest = $.ajax({
                url: settings.servicemethod,
                data: JSON.stringify(data)
            });

            ajaxRequest.done(doneHandler);
            ajaxRequest.fail(failHandler);
        }
        else {

            responseWrap.html(invalidMessage).show();
            input.focus();
        }

        function doneHandler(response) {

            if (response.Success) {
                var html = scanTemplate(response.Data);
                responseModal.append(html);

                responseModal.show();

            } else {

                displayGenericError(responseWrap, response);
            }
            cl.hide();
            scanBtn.removeClass('loading');
        }

        function failHandler(jqXHR, textStatus, errorThrown) {
            if (errorThrown == 'Forbidden') {
                var data = {
                    Errors: {
                        GenericErrors: [
                            SETTINGS.exceptions.genericloggedout
                        ]
                    }
                }
                displayGenericError(responseWrap, data);
            }
            else {
                serviceNetworkError(responseWrap);
            }
            scanBtn.removeClass('loading');
            cl.hide();
        }

        return false;
    };

    function showOlderStatitics(e) {
        e.preventDefault();
        getStatistics($(".olderstatistics", form).data("nextweek"));
    }

    function hideStatistics(e) {
        if (e) {
            e.preventDefault();
        }
        $('#statistics table', form).remove();
        form.off('click', '.statistics');
        form.on('click', '.statistics', showStatistics);
        $('.statistics', form).text($('.statistics', form).data("showtext"));
    }

    function showStatistics(e) {
        if (e) {
            e.preventDefault();
        }
        getStatistics(0);
    };

    function getStatistics(nrOfWeeksBack) {
        //Call ws
        $('#statistics table', form).remove()
        clStatistics.show();

        var data = {
            "nrOfWeeksBack": nrOfWeeksBack
        };

        var ajaxRequest = $.ajax({
            url: settings.statisticsservicemethod,
            data: JSON.stringify(data)
        });

        ajaxRequest.done(doneHandler);
        ajaxRequest.fail(failHandler);

        function doneHandler(response) {
            if (response.Success) {
                var html = statisticsTemplate(response);
                $('#statistics', form).append(html);
                form.off('click', '.statistics');
                form.on('click', '.statistics', hideStatistics);
                $('.statistics', form).text($('.statistics', form).data("hidetext"));
            }
            clStatistics.hide();
        }

        function failHandler(jqXHR, textStatus, errorThrown) {
            clStatistics.hide();
        }
    }

    function closeModal() {
        input.val('');
        input.focus();
        responseModal.empty().hide();
    }

};

var handoutPackage = (function () {
    var handoutPackageContainer = $('.handout-package');
    if (handoutPackageContainer.length > 0) {
        ticketManagementForm({
            servicemethod: SETTINGS.services.forms.methods.handoutPackage
        });
    }
})();

var activateBundle = (function () {
    var activateBundleContainer = $('.activate-bundle');
    if (activateBundleContainer.length > 0) {
        ticketManagementForm({
            servicemethod: SETTINGS.services.forms.methods.activateBundle
        });
    }
})();

var registerWinning = (function () {
    var registerWinningContainer = $('.register-winning');
    if (registerWinningContainer.length > 0) {
        ticketManagementForm({
            servicemethod: SETTINGS.services.forms.methods.registerWinning,
            statisticsservicemethod: SETTINGS.services.forms.methods.getWinningReportTransactionSummary
        });
    }
})();

var returnTicket = (function () {
    var returnTicketContainer = $('.return-ticket');
    if (returnTicketContainer.length > 0) {
        ticketManagementForm({
            servicemethod: SETTINGS.services.forms.methods.returnTicket,
            statisticsservicemethod: SETTINGS.services.forms.methods.getReturnReportTransactionSummary
        });
    }
})();